/* eslint-env browser */
import inherit from 'component-inherit';
import Query from './query';

const ua = navigator.userAgent.toLowerCase();

/**
 * Creates an FF instance
 */

export default function FF() {
  if (!(this instanceof FF)) {
    return new FF();
  }

  this.name = 'Mozilla Firefox';
  this.uaname = 'firefox';
  this.version = ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(`${this.uaname}/`)[1]) : false;
}

/**
 * Inherits FF from Query
 */

inherit(FF, Query);



// WEBPACK FOOTER //
// ./src/modules/npm-component/user-agent/ff.js